import React from 'react';

const RouteContext = React.createContext({
    containerRoute: null,
    setContainerRoute: () => {}
});

export default RouteContext;